var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"smoothWrapScroll",staticClass:"smooth-wrap-scroll"},[_c('div',{ref:"smoothContentWrap",staticClass:"smooth-content-wrap"},[_c('div',{ref:"smoothContentScroll",staticClass:"smooth-content-scroll"},[_vm._t("default")],2)]),_vm._v(" "),_c('div',{ref:"smoothScroll",staticClass:"smooth-scroll"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f40bcfd","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/lib/smooth-scroll.vue
// module id = 9
// module chunks = 0